import { render, staticRenderFns } from "./IntegrationView.vue?vue&type=template&id=2c649adf&lang=pug"
import script from "./IntegrationView.vue?vue&type=script&lang=js"
export * from "./IntegrationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports